import React from "react";
import { createRoot } from "react-dom/client";
import EventListIsland from "./EventListIsland";

const mountNode = document.getElementById("event-list-island");

if (mountNode) {
  const rawConfig = mountNode.getAttribute("data-config");

  if (rawConfig) {
    const config = JSON.parse(rawConfig);
    createRoot(mountNode).render(<EventListIsland config={config} />);
  }
}
